module.exports = __webpack_public_path__ + "static/media/TRIAL1.d097eb7a.mp3";